export default function About() {
  const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    img.style.display = 'none';
    const container = img.closest('.img-wrap') as HTMLElement | null;
    if (container) container.style.display = 'none';
  };

  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-[500px]">
            <div className="img-wrap relative w-full aspect-[3/2] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20theater%20setup%20with%20large%20screen%20displaying%20vibrant%20cinematic%20colors%2C%20cozy%20warm%20ambient%20lighting%2C%20comfortable%20viewing%20environment%2C%20warm%20wood%20tones%20and%20soft%20fabric%20textures%2C%20entertainment%20technology%20lifestyle%2C%20clean%20aesthetic%20composition%2C%20professional%20photography&width=700&height=460&seq=about-bajie-01&orientation=landscape"
                alt="八戒影视平台介绍 - 海量影视资源免费在线观看"
                className="absolute inset-0 w-full h-full object-cover"
                width="700"
                height="460"
                onError={handleImgError}
              />
            </div>
          </div>
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              关于八戒影视
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              八戒影视网是一个专注于高清影视内容聚合的免费在线观看平台。我们致力于为观众提供最新、
              最全的电影、电视剧、综艺和动漫资源，覆盖国内外热门作品与经典佳作。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台采用先进的视频编码与CDN加速技术，确保每一部影片都能实现秒速加载、流畅播放，
              告别缓冲等待。无论是追剧党、电影爱好者还是动漫迷，都能在这里找到心仪的内容。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              内容覆盖动作、喜剧、爱情、悬疑、科幻、动画等多种类型，每日同步更新最新上架资源，
              让您不错过任何一部精彩作品。八戒影视，让观影变得更简单。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}